/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";
import { useNavigate } from "react-router-dom";

import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Icon from "@mui/material/Icon";
import Avatar from "@mui/material/Avatar";

import profileImage from "assets/images/avatar.png";
import { logout } from "utils/authToken";

function DashboardNavbar({ username, distinction }) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleLogout = () => {
    logout();
    setAnchorEl(null);
    navigate("/authentication/sign-in");
  };

  return (
    <Box
      sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 1, pt: 2 }}
    >
      {username ? (
        <Box sx={{ display: { xs: "block", lg: "none" }, pl: 2 }}>
          <Box sx={{ fontSize: "1.25rem", fontWeight: 700, lineHeight: 1.2 }}>Hi {username}!</Box>
          <Box
            sx={{
              fontSize: "0.7rem",
              fontWeight: 700,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              color: "text.secondary",
              mt: 0.25,
            }}
          >
            {distinction}
          </Box>
        </Box>
      ) : (
        <Box />
      )}
      <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)} sx={{ ml: "auto" }}>
        <Avatar alt="User Profile" src={profileImage} sx={{ width: 42, height: 42 }} />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ mt: 1 }}
      >
        {/* On mobile this menu and the bottom tab bar are the whole nav — the
            sidenav is hidden below lg. Your Kitchen also has its own bottom
            tab now, but stays here too since Profile and Support have no tab
            of their own and this is their only route on a phone. */}
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            navigate("/your-kitchen");
          }}
        >
          <Icon sx={{ mr: 1 }}>local_fire_department</Icon>Your Kitchen
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            navigate("/profile");
          }}
        >
          <Icon sx={{ mr: 1 }}>account_circle</Icon>Profile
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            navigate("/support");
          }}
        >
          <Icon sx={{ mr: 1 }}>help_outline</Icon>Support
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <Icon sx={{ mr: 1 }}>logout</Icon>Logout
        </MenuItem>
      </Menu>
    </Box>
  );
}

DashboardNavbar.defaultProps = {
  username: "",
  distinction: "",
};
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  username: PropTypes.string,
  distinction: PropTypes.string,
};

export default DashboardNavbar;
